export const METAL_FINISHES = ['Gold plated','Silver plated','Black nickel','Antique gold','Antique silver','Antique copper','Rose gold','Two tone']
export const BACK_ATTACHMENTS = ['Butterfly clutch','Military clutch','Magnetic clutch','Rubber clutch','Safety pin','No attachment']
export const SPECIAL_EFFECTS = ['Spinner','Danglers','Glitter','Glow in the dark','Cut out','Translucent enamel','Transparent enamel','Gemstones','Bobble']

export const PRODUCT_SPECS: Record<string, any> = {
  'Pin': {
    sizes: ['0.75"','1"','1.25"','1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    enamelStyle: { multi: false, options: ['Soft Enamel','Hard Enamel','Die Struck','Offset Printed','3D'] },
    attachment: { multi: false, options: BACK_ATTACHMENTS },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Trading Pin': {
    sizes: ['0.75"','1"','1.25"','1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    enamelStyle: { multi: false, options: ['Soft Enamel','Hard Enamel','Die Struck','Offset Printed','3D'] },
    attachment: { multi: false, options: BACK_ATTACHMENTS },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Medal': {
    sizes: ['1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"','3.25"','3.5"','3.75"','4"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    ribbon: { multi: false, options: ['Stock ribbon','Sublimated ribbon','No ribbon'] },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Coin': {
    sizes: ['1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    edge: { multi: false, options: ['Flat edge','Rope edge','Reeded edge'] },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Charm': {
    sizes: ['0.5"','0.75"','1"','1.25"','1.5"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    attachment: { multi: false, options: BACK_ATTACHMENTS },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Key Chain': {
    sizes: ['1"','1.25"','1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    attachment: { multi: false, options: BACK_ATTACHMENTS },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'Belt Buckle': {
    sizes: ['2.5"','2.75"','3"','3.25"','3.5"','3.75"','4"'],
    metalFinish: { multi: true, options: METAL_FINISHES },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  },
  'PVC Patch': {
    sizes: ['1"','1.25"','1.5"','1.75"','2"','2.25"','2.5"','2.75"','3"','3.25"','3.5"','3.75"','4"'],
    construction: { multi: false, options: ['Stroke outline','Debossed','Embossed'] },
    effects: { multi: true, options: SPECIAL_EFFECTS }
  }
}

export const SPEC_LABELS: Record<string, string> = {
  size: 'Size',
  metalFinish: 'Metal Finish',
  enamelStyle: 'Enamel Style',
  attachment: 'Back Attachment',
  backstamp: 'Backstamp',
  backerCard: 'Backer Card',
  effects: 'Special Effects',
  ribbon: 'Ribbon',
  edge: 'Edge',
  construction: 'Construction'
}
